import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
import { useUserRole } from "../../Transactions/hooks/useUserRole";
import { useTransactionData } from "../../Transactions/hooks/useTransactionData";
import { useIsGamingMerchant } from "../../../hooks/useIsGamingMerchant";
import TransactionTableTanStack from "../../Transactions/components/tables/TransactionTableTanStack";
import CustomSkeletonTable from "../../ui/CustomSkeletonTable/CustomSkeletonTable";
import FetchFeedback from "../../ui/CustomFetchFeedback/CustomFetchFeedback";
import CustomButton from "../../ui/CustomButton/CustomButton";

export default function RecentPayoutsSection() {
  const navigate = useNavigate();
  const { isSuperAdmin } = useUserRole();
  const { isGamingMerchant } = useIsGamingMerchant();
  const canSeeKraFee = isSuperAdmin || isGamingMerchant;

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const { transactions, isLoading, isFetching, isError, refetch } =
    useTransactionData({
      apiFilters: { size: pagination.pageSize },
      managementApiFilters: { size: pagination.pageSize },
      isSuperAdmin,
    });

  const handleSeeAllClick = () => {
    navigate("/transaction-page");
  };

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-4 sm:mb-6">
        <h1 className="text-base sm:text-lg font-semibold text-gray-900">Recent payouts</h1>
        <CustomButton size="xs" onClick={handleSeeAllClick}>
          see all <FiChevronRight className="w-4 h-4 sm:w-5 sm:h-5" />
        </CustomButton>
      </div>

      {isLoading && (
        <CustomSkeletonTable
          columns={[1, 2, 3, 4, 5, 6, 7, 8]}
          rowCount={pagination.pageSize}
        />
      )}

      {isError && (
        <FetchFeedback
          message="Failed to load recent payouts."
          onRetry={refetch}
        />
      )}

      {!isLoading && !isError && (
        <TransactionTableTanStack
          data={transactions}
          pagination={pagination}
          onPaginationChange={setPagination}
          isLoading={isLoading}
          isFetching={isFetching}
          isSuperAdmin={isSuperAdmin}
          canSeeKraFee={canSeeKraFee}
          compact
        />
      )}
    </div>
  );
}
